"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _LanguageSwitcher = _interopRequireDefault(require("./LanguageSwitcher"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _LanguageSwitcher.default;
exports.default = _default;